/**
 * Exporta datos a CSV adaptándose a los formatos de Hacienda El Salvador para DTE.
 */
export function useReportExcelExporter(data, filename = 'reporte.csv', headerLabels = null, headerKeys = null, reportType = 'generic') {
    if (!data || data.length === 0) {
        alert("No hay datos para exportar.");
        return;
    }

    let csvContent = "";

    // --- LÓGICA PARA HACIENDA (DTE-01 y DTE-03) ---
    if (reportType === 'dte_01' || reportType === 'dte_03') {
        // Hacienda prohíbe encabezados en la carga de archivos
        csvContent = data.map(row => {
            if (reportType === 'dte_03') {
                return [
                    formatDateHacienda(row.fecha_emision),    // A: Fecha
                    "4",                                     // B: Clase (DTE)
                    "03",                                    // C: Tipo (CCF)
                    cleanString(row.numero_control),         // D: Res. (Num Control)
                    cleanString(row.dte_stamp_code || ''),   // E: Serie (Sello)
                    cleanString(row.codigo_generacion),      // F: Doc. (Cod Gen)
                    "",                                      // G: Control Interno
                    cleanString(row.nrc || row.client_nit),  // H: NIT/NRC
                    row.nombre_cliente,                      // I: Nombre
                    cleanNum(row.venta_exenta),              // J: Exenta
                    "0.00",                                  // K: No Sujeta
                    cleanNum(row.venta_gravada),             // L: Gravada
                    cleanNum(row.debito_fiscal_iva),         // M: Débito
                    "0.00",                                  // N: Terceros
                    "0.00",                                  // O: Débito Terceros
                    cleanNum(row.total_venta),               // P: Total
                    "",                                      // Q: DUI
                    "1",                                     // R: Renta Op
                    "3",                                     // S: Renta Ingreso
                    "1"                                      // T: Anexo 1
                ].join(';');
            } else if(reportType==='dte_01') {

                    return [
                        formatDateHacienda(row.report_date), // A
                        "4",                                // B
                        "01",                               // C
                        "N/A",                              // D
                        "N/A",                              // E
                        "N/A",
                        "N/A",
                        cleanString(row.first_code_gen),                          // F
                        cleanString(row.first_code_gen),                            // G
                        "",                                 // J (Blanco)
                        cleanNum(row.total_excent),         // K
                        "0.00",                             // L
                        "0.00",                             // M
                        cleanNum(row.total_sales),          // N (Con IVA incluido)
                        cleanNum(row.total_export),         // O
                        "0.00",                             // P
                        "0.00",                             // Q
                        "0.00",                             // R
                        cleanNum(row.total_thirds),         // S
                        cleanNum(row.total_sales),          // T
                        "1",                                // U (Renta 2025)
                        "3",                                // V (Renta 2025)
                        "2"                                 // W (Anexo 2)
                    ].join(';');
            }
        }).join('\n');
    } else {
        // --- LÓGICA PARA REPORTES GENÉRICOS (TU CÓDIGO ORIGINAL) ---
        const keys = headerKeys || Object.keys(data[0]);
        const labels = headerLabels || keys;
        const finalHeaders = ['#', ...labels];

        csvContent = finalHeaders.join(',') + '\n';

        csvContent += data.map((row, index) => {
            const rowValues = [String(index + 1)];
            const existingValues = keys.map(key => {
                let value = row[key] === null || row[key] === undefined ? '' : String(row[key]);
                if (value.includes(',') || value.includes('\n') || value.includes('"')) {
                    value = `"${value.replace(/"/g, '""')}"`;
                }
                return value;
            });
            return rowValues.concat(existingValues).join(',');
        }).join('\n');
    }

    // --- DESCARGA ---
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

/** HELPERS DE LIMPIEZA PARA HACIENDA */

// Formato DD/MM/AAAA
function formatDateHacienda(dateString) {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
}

/*function formatDateHacienda(dateString) {
    if (!dateString) return '';

    // Suponiendo que dateString viene como "YYYY-MM-DD" o "YYYY-MM-DD HH:mm:ss"
    const parts = dateString.split(/[- :]/);
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];

    return `${day}${month}${year}`; // Retorna solo números
}*/

// Números sin comas, con 2 decimales
function cleanNum(val) {
    const num = parseFloat(val || 0);
    return num.toFixed(2);
}

// Quitar guiones de NIT, NRC, Controles
function cleanString(val) {
    return String(val || '').replace(/[-/]/g, '').trim();
}
